<p-dialog
  *ngIf="topic"
  [appendTo]="'body'"
  [(visible)]="detailsControl.isOpen"
  [position]="'right'"
  [style]="{ width: '55vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  (visibleChange)="hideDialog()"
>
  <div class="flex justify-content-between align-items-center mt-2">
    <div class="flex gap-2 align-items-center">
      <button class="secondary-button p-0 mr-2" (click)="hideDialog()" data-clarity-unmask="true">
        X
      </button>
    </div>
  </div>

  <ng-template pTemplate="content">
    <div
      class="flex flex-column md:flex-row justify-content-between align-content-center mt-3 md:mt-5 mb-3 gap-1 md:gap-3"
    >
      <div class="font-semibold text-xl">{{ topic.name }}</div>
      <div
        *ngIf="topic.created"
        class="flex justify-content-start md:justify-content-center align-items-center text-sm text-400"
      >
        Edytowano: {{ topic.created | date : "dd.MM.yyyy HH:mm" }}
      </div>
    </div>

    <p-tabView>
      <p-tabPanel header="Dane podstawowe">
        <form [formGroup]="topicForm">
          <div
            class="form-decorator flex w-full justify-content-left align-items-center mb-6"
          >
            <div class="title">Przypisany dział wykładu</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="topic.elearningTopicCategoryName || 'Brak działu'"
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing" class="w-full">
                <p-dropdown
                  id="elearningTopicCategoryId"
                  formControlName="elearningTopicCategoryId"
                  [options]="availableCategories"
                  optionValue="id"
                  optionLabel="name"
                  placeholder="Wybierz dział"
                  class="w-full"
                  styleClass="w-full"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div
            class="form-decorator top-decorator flex w-full justify-content-left align-items-center"
          >
            <div class="title">Domyślna nazwa rozdziału wykładu (PL)</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="topic.name || 'Brak nazwy głównej'"
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing">
                <div class="flex align-items-center gap-2">
                  <input
                    type="text"
                    class="default-input w-full flex-1"
                    formControlName="name"
                    placeholder="Wprowadź nazwę główną rozdziału"
                    [class.input-error]="
                      topicForm.get('name')?.invalid &&
                      topicForm.get('name')?.touched
                    "
                  />
                </div>

                <div
                  *ngIf="
                    topicForm.get('name')?.invalid &&
                    topicForm.get('name')?.touched
                  "
                  class="error-message mt-1"
                >
                  Nazwa główna jest wymagana.
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-decorator flex w-full justify-content-left align-items-center"
          >
            <div class="title">Kolejność wyświetlania</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="topic.order || 0"
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing" class="w-full">
                <input
                  type="number"
                  class="default-input w-full"
                  formControlName="order"
                  placeholder="0"
                  min="0"
                />
              </div>
            </div>
          </div>
        </form>

        <div
          class="form-decorator flex w-full justify-content-left align-items-center"
        >
          <div class="title">Domyślny plik grficzny (PL)</div>
          <div class="w-full">
            <div
              *ngIf="!editingThumbnail"
              class="flex justify-content-between align-items-center"
            >
              <img
                *ngIf="topic.thumbnailUrl; else noThumbnail"
                [src]="
                  environment.webApiUrl +
                  topic.thumbnailUrl.replace('/media', '/uploadMedia')
                "
                alt="Thumbnail"
                width="200"
              />
              <ng-template #noThumbnail
                ><span class="text-sm text-400"
                  >Brak pliku graficznego</span
                ></ng-template
              >
              <div class="flex gap-2">
                <button
                  pTooltip="Edytuj plik graficzny"
                  type="button"
                  class="transparent-button"
                  [disabled]="
                    detailsControl.isEditing || isAnyTranslationBeingEdited()
                  "
                  (click)="enableThumbnailEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-pencil"></i>
                </button>

                <button
                  *ngIf="topic.thumbnailUrl"
                  type="button"
                  class="transparent-button text-red-500"
                  [disabled]="
                    savingThumbnail ||
                    detailsControl.isEditing ||
                    isAnyTranslationBeingEdited()
                  "
                  (click)="removeThumbnail()"
                  title="Usuń plik graficzny"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-spin pi-spinner" *ngIf="savingThumbnail"></i>
                  <i class="pi pi-trash" *ngIf="!savingThumbnail"></i>
                </button>
              </div>
            </div>

            <div *ngIf="editingThumbnail">
              <div class="mb-3">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
                  [mainIcon]="'pi-image'"
                  [multiple]="false"
                  (fileSelected)="onMainThumbnailSelected($event)"
                ></fas-services-upload>
              </div>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Zapisz miniaturę"
                  [disabled]="savingThumbnail || !selectedThumbnailFile"
                  (click)="saveThumbnail()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-check" *ngIf="!savingThumbnail"></i
                  ><i class="pi pi-spin pi-spinner" *ngIf="savingThumbnail"></i>
                </button>
                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Anuluj edycję miniatury"
                  [disabled]="savingThumbnail"
                  (click)="cancelThumbnailEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Wersje językowe">
        <div class="mt-3">
          <div *ngFor="let language of availableLanguages" class="mb-6">
            <div *ngIf="!language.isDefault">
              <details class="translation-card">
                <summary
                  class="translation-summary cursor-pointer flex justify-content-between align-items-center text-gray-500"
                >
                  <div>
                    <i class="pi pi-flag mr-2"></i>Wersja językowa:
                    {{ language.name }} ({{ language.code.toUpperCase() }})
                  </div>
                  <i class="pi pi-angle-down"></i>
                </summary>

                <div class="translation-body p-3">
                  <div
                    class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center mb-4"
                  >
                    <div class="title">
                      Nazwa rozdziału wykładu ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationName[language.code]"
                        class="flex align-items-center"
                      >
                        <input
                          type="text"
                          class="default-input input-off w-full flex-1"
                          [value]="
                            getTranslationName(language.code) ||
                            'Brak nazwy tłumaczenia'
                          "
                          readonly
                        />
                        <div class="flex gap-2">
                          <button
                            pTooltip="Edytuj nazwę tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="
                              !canEditTranslationField(language.code, 'name')
                            "
                            (click)="
                              enableTranslationNameEditing(language.code)
                            "
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                            pTooltip="Usuń tłumaczenie"
                            type="button"
                            class="transparent-button"
                            *ngIf="getTranslationName(language.code)"
                            [disabled]="
                              !canEditTranslationField(language.code, 'name')
                            "
                            (click)="deleteTranslation(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-trash"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationName[language.code]">
                        <form
                          [formGroup]="translationNameForms[language.code]"
                          (ngSubmit)="saveTranslationName(language.code)"
                        >
                          <div class="flex align-items-center gap-2">
                            <input
                              type="text"
                              class="default-input w-full flex-1"
                              formControlName="name"
                              placeholder="Wprowadź nazwę tłumaczenia"
                              [class.input-error]="
                                translationNameForms[language.code].get('name')
                                  ?.invalid &&
                                translationNameForms[language.code].get('name')
                                  ?.touched
                              "
                            />
                            <div class="flex gap-2">
                              <button
                                type="button"
                                class="transparent-button"
                                pTooltip="Zapisz nazwę tłumaczenia"
                                [disabled]="
                                  savingTranslationName[language.code]
                                "
                                (click)="saveTranslationName(language.code)"
                                data-clarity-unmask="true"
                              >
                                <i
                                  class="pi pi-check"
                                  *ngIf="!savingTranslationName[language.code]"
                                ></i
                                ><i
                                  class="pi pi-spin pi-spinner"
                                  *ngIf="savingTranslationName[language.code]"
                                ></i>
                              </button>
                              <button
                                type="button"
                                class="transparent-button"
                                pTooltip="Anuluj edycję nazwy tłumaczenia"
                                [disabled]="
                                  savingTranslationName[language.code]
                                "
                                (click)="
                                  cancelTranslationNameEditing(language.code)
                                "
                                data-clarity-unmask="true"
                              >
                                <i class="pi pi-times"></i>
                              </button>
                            </div>
                          </div>
                          <div
                            *ngIf="
                              translationNameForms[language.code].get('name')
                                ?.invalid &&
                              translationNameForms[language.code].get('name')
                                ?.touched
                            "
                            class="error-message mt-1"
                          >
                            Nazwa tłumaczenia jest wymagana.
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-decorator flex w-full justify-content-left align-items-center"
                  >
                    <div class="title">
                      Plik graficzny ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationThumbnail[language.code]"
                        class="flex justify-content-between align-items-center"
                      >
                        <img
                          *ngIf="
                            getTranslationThumbnail(language.code);
                            else noTranslationThumbnail
                          "
                          [src]="
                            environment.webApiUrl +
                            getTranslationThumbnail(language.code).replace(
                              '/media',
                              '/uploadMedia'
                            )
                          "
                          alt="Translation Thumbnail"
                          width="200"
                        />
                        <ng-template #noTranslationThumbnail
                          ><span class="text-sm text-400"
                            >Brak pliku graficznego</span
                          ></ng-template
                        >
                        <div class="flex gap-2">
                          <button
                            pTooltip="Edytuj plik graficzny tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="
                              !canEditTranslationField(
                                language.code,
                                'thumbnail'
                              )
                            "
                            (click)="
                              enableTranslationThumbnailEditing(language.code)
                            "
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                            pTooltip="Usuń plik graficzny tłumaczenia"
                            type="button"
                            class="transparent-button"
                            *ngIf="getTranslationThumbnail(language.code)"
                            [disabled]="
                              !canEditTranslationField(
                                language.code,
                                'thumbnail'
                              )
                            "
                            (click)="deleteTranslation(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-trash"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationThumbnail[language.code]">
                        <div class="mb-3">
                          <fas-services-upload
                            [environment]="environment.webApiUrl"
                            [allowedExtensions]="[
                              '.png',
                              '.jpg',
                              '.jpeg',
                              'webp'
                            ]"
                            [mainIcon]="'pi-image'"
                            [multiple]="false"
                            (fileSelected)="
                              onTranslationThumbnailSelected(
                                $event,
                                language.code
                              )
                            "
                          ></fas-services-upload>
                        </div>
                        <div class="flex gap-2">
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Zapisz miniaturę tłumaczenia"
                            [disabled]="
                              savingTranslationThumbnail[language.code] ||
                              !selectedTranslationFiles[language.code]
                            "
                            (click)="saveTranslationThumbnail(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i
                              class="pi pi-check"
                              *ngIf="!savingTranslationThumbnail[language.code]"
                            ></i
                            ><i
                              class="pi pi-spin pi-spinner"
                              *ngIf="savingTranslationThumbnail[language.code]"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Anuluj edycję miniatury tłumaczenia"
                            [disabled]="
                              savingTranslationThumbnail[language.code]
                            "
                            (click)="
                              cancelTranslationThumbnailEditing(language.code)
                            "
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </details>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex flex-wrap gap-2 w-full align-items-center justify-content-between mb-2">
      <div *ngIf="detailsControl.isEditing" class="flex gap-2">
        <p-button
          [disabled]="!topicForm.valid || isSaving"
          (onClick)="saveTopic()"
          label="Zapisz zmiany"
          [icon]="isSaving ? 'pi pi-spin' : 'pi pi-save'"
          data-clarity-unmask="true"
        ></p-button>
        <p-button
          label="Anuluj"
          [link]="true"
          (onClick)="editToggle()"
          [disabled]="isSaving"
          data-clarity-unmask="true"
        >
        </p-button>
      </div>

      <div *ngIf="!detailsControl.isEditing">
        <p-button
          label="Edytuj"
          icon="pi pi-pencil"
          (onClick)="editToggle()"
          [disabled]="isAnyTranslationBeingEdited()"
          [title]="
            isAnyTranslationBeingEdited()
              ? 'Zakończ edycję tłumaczenia przed rozpoczęciem edycji głównego formularza'
              : ''
          "
          data-clarity-unmask="true"
        >
        </p-button>
      </div>

      <p-button
        icon="pi pi-trash"
        label="Usuń rozdział"
        [outlined]="true"
        (onClick)="deleteTopic()"
        data-clarity-unmask="true"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>
